<div class="col-xs-12">
    <div style="margin: 10px;" class="text-right">
        <button id="addUserButton" class="btn btn-primary"
            *ngIf="userDetails.roleName === '4dot5SuperUser' || userDetails.roleName === '4dot5Admin' || !addUserNotEnabled"
            (click)="addUser()"
            style="margin-bottom: 2px; margin: 15px;"
            [disabled]="companyState === 'SoftHold'">
            Add User
        </button>
        <input type="text" placeholder="Search" [(ngModel)]="searchTerm" (ngModelChange)="filterUsers()"
            class="text-center filter-style" />
    </div>
</div>

<!-- Users Grid -->
<div class="row testDiv bottomgap">
    <!-- No Users Found -->
    <div *ngIf="(!isUserRowViewActive && (teamMemberLoaded && filteredTeamMemberData.length === 0)) ||
                (isUserRowViewActive && (teamMemberLoaded && rowViewUserData.length === 0))"
        style="text-align: center; font-size: 24px; color: gray;">
        <p class="mb-3">No Users Found!</p>
        <img src="assets/app-content/img/no_users.svg" style="height: 200px" alt="No Candidates Found">
    </div>

    <!-- Loading Spinner -->
    <div class="row" *ngIf="!teamMemberLoaded">
        <div class="col-xs-12 no_candidates_found text-center">
            <span>Loading</span>
            <span class="fa fa-spinner fa-spin"></span>
        </div>
    </div>

    <!-- Card View -->
    <ng-container *ngIf="!isUserRowViewActive && teamMemberLoaded">
        <ng-container *ngFor="let teamMember of filteredTeamMemberData; trackBy: trackByUserId; let i = index">
            <div class="col-lg-4 col-md-5 col-sm-6">
                <app-user-card
                    [userInfo]="teamMember"
                    [managers]="managers"
                    [activityMap]="activityMap"
                    [isUserRowViewActive]="isUserRowViewActive"
                    (deleteUserCallback)="deleteUser()">
                </app-user-card>
            </div>
            <!-- Bootstrap 3 clearfix to prevent float stagger when cards have unequal heights -->
            <div class="clearfix visible-lg-block" *ngIf="(i + 1) % 3 === 0"></div>
            <div class="clearfix hidden-lg" *ngIf="(i + 1) % 2 === 0"></div>
        </ng-container>
    </ng-container>

    <!-- Row View -->
    <div class="col-sm-12" *ngIf="isUserRowViewActive && teamMemberLoaded">
        <div *ngIf="rowViewUserData.length > 0">
            <ul class="list-unstyled">
                <li class="my-3" *ngFor="let user of rowViewUserData; trackBy: trackByUserId">
                    <div class="tree-node position-relative mr-3">
                        <div class="d-flex flex-nowrap align-items-center">
                            <app-user-card
                                class="col-xs-12"
                                [userInfo]="user"
                                [managers]="managers"
                                [activityMap]="activityMap"
                                [isUserRowViewActive]="isUserRowViewActive"
                                (deleteUserCallback)="deleteUser()">
                            </app-user-card>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
